import Model from '../../ModelBinding/Model';
import LanguageCollection from './LanguageCollection';
import LanguageTranslationCollection from '../LanguageTranslation/LanguageTranslationCollection';
import dayjs from 'dayjs';

export default class Language extends Model {
  public code?: string;
  public name?: string;
  public direction?: string;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;
  public translations?: LanguageTranslationCollection;

  bind() {
    this.code = this.getStringAttribute('code');
    this.name = this.getStringAttribute('name');
    this.direction = this.getStringAttribute('direction');
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.translations = this.getRelationAttributeCollection('translations', LanguageTranslationCollection) as LanguageTranslationCollection;
  }

  static getCollection() {
    return LanguageCollection;
  }

  get localeName() {
    if (!this.translations) return this.name;

    const translation = this.translations.find(({ locale }) => locale === this.code);
    if (translation) return translation.name;

    const englishTranslation = this.translations.find(({ locale }) => locale === 'en');
    if (englishTranslation) return englishTranslation.name;

    return this.name;
  }
}
